import script from "./LeagueRoundStandingsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueRoundStandingsView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueRoundStandingsView.vue?vue&type=style&index=0&id=1518971c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1518971c"]])

export default __exports__